import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';
import { __DEV__ } from '~src/config';

import { loadTenderSubFolders } from '~src/services/api';
import { DbTenderFolder } from '~src/types/db';
import { useProjectId } from '../useProjectId';
import { useArchiveSettings } from './useArchiveSettings';
import { useProject } from './useProject';

interface UseTenderFoldersParams {
  favourites?: boolean;
  before?: number;
  search_name?: string;
  search_description?: string;
  as_admin?: boolean;
  after?: number;
  show_deleted?: boolean;
  root_folder_id?: string;
}
export const useTenderFoldersFolders = (
  {
    favourites,
    before,
    search_name,
    search_description,
    as_admin,
    show_deleted,
    after,
    root_folder_id,
  }: UseTenderFoldersParams = {},
  queryConfig: QueryConfig<DbTenderFolder[], AxiosError> & {
    enabled?: boolean;
  } = {}
) => {
  const projectId = useProjectId();
  const projectQuery = useProject();
  const archiveSettings = useArchiveSettings();
  const isTenderingOn =
    archiveSettings.data?.resArchiveSettings?.is_tendering_on &&
    (projectQuery?.data?.is_tender_admin || projectQuery?.data?.is_superuser);
  const { enabled, ...options } = queryConfig;
  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const tenderSubFoldersQuery = useQuery<DbTenderFolder[], AxiosError>(
    [
      'tenderFoldersFolders',
      {
        projectId: String(projectId),
        favourites,
        before,
        search_name,
        search_description,
        as_admin,
        after,
        show_deleted,
        root_folder_id,
      },
    ],
    (key, args) => loadTenderSubFolders(args),
    {
      // refetch every 5 min
      refetchInterval: 5 * 60 * 1000,
      enabled:
        enabledOverwrite &&
        projectId &&
        isTenderingOn &&
        root_folder_id &&
        root_folder_id !== 'undefined',
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );
  return tenderSubFoldersQuery;
};
